export function assertNever (x: never): void {
  throw new Error(`AssertNever: ${x}`);
}

// used to cause a typescript type error without throwing an actual error
// eslint-disable-next-line unused-imports/no-unused-vars-ts
export function checkNever (x: never): undefined {
  return undefined;
}
